import { Component, EventEmitter, Inject, Input, NgZone, OnInit, OnChanges, Output, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { take } from 'rxjs/operators';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { GridComponent, GridDataResult, DataStateChangeEvent, RowClassArgs } from '@progress/kendo-angular-grid';
import { process, State } from '@progress/kendo-data-query';
import { CommentService } from '../../services/comment.service';
import { CityService } from '../../services/city.service';
import { ContactService } from '../../services/contact.service';
import { CSEService } from '../../services/cse.service';
import { EmployeeService } from '../../services/employees.service';
import { NotificationService } from '../../services/notification.service';
import { OrderService } from '../../services/order.service';
import { UtilService } from '../../services/util.service';
import {
    CarrierService
    , City
    , Employee
    , EquipmentClass
    , Mode
    , SearchCarrierProc
    , SearchCarrierCriteria
    , SearchTrailerEquipmentClass
    , TrailerType
} from '../../models/models';

@Component({
    selector: 'carrier-search-grid',
    templateUrl: './carrier-search-grid.component.html',
    standalone: false
})
export class CarrierSearchGrid implements OnInit, OnChanges {
    @Input() employees: Employee[] = [];
    @Input() refreshDate: Date = new Date();
    @Output() onCarrierClick = new EventEmitter<any>();
    @Output() refreshData = new EventEmitter<any>();

    @ViewChild(GridComponent, { static: false }) public carrierSearchGrid!: GridComponent;

    public carrier: SearchCarrierProc = {} as SearchCarrierProc;

    private domiciledCity: City = {} as City;
    private originCity: City = {} as City;
    private destinationCity: City = {} as City;

    public searchCarrierCriteria: SearchCarrierCriteria = {} as SearchCarrierCriteria;
    private searchCarrierList: SearchCarrierProc[] = [];
    public filteredSearchCarrierList: SearchCarrierProc[] = [];
    public searchTrailerEquipmentClassList: SearchTrailerEquipmentClass[] = [];
    public filteredTrailerEquipmentClassList: SearchTrailerEquipmentClass[] = [];
    public carrierRepList: Employee[] = [];
    public modeList: Mode[] = [];
    public trailerTypeList: TrailerType[] = [];
    public equipmentClassList: EquipmentClass[] = [];
    public carrierServiceList: CarrierService[] = [];
    public isAddCarrier: boolean = false;
    public isLoading: boolean = false;
    public isSaving: boolean = false;
    public isCustomerExcluded: boolean = false;
    private carrierID: number = 0;
    public geocodeLaneID: number = 0;
    public min: number = 1;
    public max: number = 4;
    public countryCode: string = "US";
    public searchType: string = "domiciled";

    public searchGridState: State = { skip: 0, take: 25, sort: [{ dir: 'asc', field: 'carrierCode' }] };
    public searchGridData: GridDataResult = { data: [], total: 0 };

    public divFlags = {
        'search': true
    };

    public searchCarrierForm: UntypedFormGroup = new UntypedFormGroup({
        domiciledCityStateZipCtrl: new UntypedFormControl(''),
        originCityStateZipCtrl: new UntypedFormControl(''),
        destinationCityStateZipCtrl: new UntypedFormControl('')
    });

    constructor(private cityService: CityService, private commentService: CommentService, private contactService: ContactService,
        private cseService: CSEService, private employeeService: EmployeeService, private notificationService: NotificationService,
        public orderService: OrderService, public utilService: UtilService, private titleService: Title,
        private ngZone: NgZone, @Inject('BASE_URL') private baseUrl: string) {

        this.titleService.setTitle("Carriers");
    }

    ngOnInit() {
        this.initValues();

        this.orderService.getModes().subscribe(result => {
            var modes = result;
            modes = modes.sort((left, right): number => {
                if (left.abbrev < right.abbrev) return -1;
                if (left.abbrev > right.abbrev) return 1;
                return 0;
            });
            this.modeList = modes;
        });

        this.orderService.getTrailerTypes().subscribe(result => {
            var trailerTypes = result;
            trailerTypes = trailerTypes.filter(t => t.allowedOnLanes == true);
            trailerTypes = trailerTypes.sort((left, right): number => {
                if (left.abbrev < right.abbrev) return -1;
                if (left.abbrev > right.abbrev) return 1;
                return 0;
            });
            this.trailerTypeList = trailerTypes;
        });

        this.getCarrierReps();
        this.getEquipmentClasses();
        this.getSearchTrailerEquipmentClass();
        this.getGetCarrierServices();
        //console.log("carrier-search-grid:ngOnInit", this.editedCarrierList);
    }

    ngOnChanges() {
        this.initValues();
        //console.log("carrier-list-grid:ngOnChanges", this.editedCarrierList);
    }

    ngAfterViewInit() {
    //    this.offerRateField.nativeElement.focus();
    }

    public toggleFlag(div: string) {
        this.divFlags[div] = !this.divFlags[div];
    }

    private initValues() {
        this.searchCarrierList = [];
        this.domiciledCity = {} as City;
        this.originCity = {} as City;
        this.destinationCity = {} as City;
        this.searchCarrierCriteria = {
            domiciledCityID: 0,
            domiciledRadiusMiles: 0,
            assignedEmployeeID: 0,
            originCityID: 0,
            originRadiusMiles: 0,
            destinationCityID: 0,
            destinationRadiusMiles: 0,
            modeID: 0,
            trailerTypeID: 0,
            equipmentClassID: 0,
            equipmentClassIDs: "",
            carrierServiceID: 0,
            carrierServiceIDs: "",
            isRoundTrip: false
        };
        this.searchCarrierForm.controls["domiciledCityStateZipCtrl"].setValue({} as City);
        this.searchCarrierForm.controls["originCityStateZipCtrl"].setValue("");
        this.searchCarrierForm.controls["destinationCityStateZipCtrl"].setValue("");
    }

    public getSearchType(searchType) {
        this.searchType = searchType;
        //if (searchType == "domiciled") {
        //    this.searchCarrierCriteria.originCityID = 0;
        //    this.searchCarrierCriteria.originRadiusMiles = 0;
        //    this.searchCarrierCriteria.destinationCityID = 0;
        //    this.searchCarrierCriteria.destinationRadiusMiles = 0;
        //    this.searchCarrierCriteria.modeID = 0;
        //    this.searchCarrierCriteria.trailerTypeID = 0;
        //    this.searchCarrierCriteria.isRoundTrip = false;
        //}
        //else if (searchType == "lane") {
        //    this.searchCarrierCriteria.domiciledCityID = 0;
        //    this.searchCarrierCriteria.domiciledRadiusMiles = 0;
        //    this.searchCarrierCriteria.assignedEmployeeID = 0;
        //}
        this.initValues();
    }

    private getCarrierReps() {
        this.employeeService.getEmployeesByGroupName('CarrierRep').subscribe(result => {
            var emps = result;
            emps = emps.sort((left, right): number => {
                if (left.fullName < right.fullName) return -1;
                if (left.fullName > right.fullName) return 1;
                return 0;
            });
            for (var i = 0; i < emps.length; i++) {
                emps[i].winUserName = (emps[i].winUserName == null ? "" : emps[i].winUserName.toUpperCase());
            }
            this.carrierRepList = emps;
        });
    }

    public citySTChanged(evt: any, cityType: string) {
        var cityID = evt;
        console.log("citySTChanged", cityID, cityType);
        this.cityService.getCityByID(cityID).subscribe(result => {
            if (result.resultCollection.length > 0) {
                if (cityType == "domiciled") {
                    this.domiciledCity = result.resultCollection[0];
                    this.searchCarrierCriteria.domiciledCityID = this.domiciledCity.cityID;
                }
                else if (cityType == "origin") {
                    this.originCity = result.resultCollection[0];
                    this.searchCarrierCriteria.originCityID = this.originCity.cityID;
                }
                else if (cityType == "destination") {
                    this.destinationCity = result.resultCollection[0];
                    this.searchCarrierCriteria.destinationCityID = this.destinationCity.cityID;
                }
                console.log("citySTChanged:customerCity", cityID, result);
            }
            else {
                this.notificationService.showWarning("Invalid or missing city.", "WARNING: Invalid City");
            }
        });
    }

    private getEquipmentClasses() {
        this.isLoading = true;
        this.cseService.getEquipmentClasses().subscribe(result => {
            this.equipmentClassList = result.resultCollection;
            this.isLoading = false;
        });
    }

    private getSearchTrailerEquipmentClass() {
        this.isLoading = true;
        this.cseService.getSearchTrailerEquipmentClass().subscribe(result => {
            this.searchTrailerEquipmentClassList = result.resultCollection;
            this.searchTrailerEquipmentClassList = this.searchTrailerEquipmentClassList.filter(t => t.allowedOnLanes == true);
            this.filteredTrailerEquipmentClassList = Object.assign([], this.searchTrailerEquipmentClassList);
            this.isLoading = false;
        });
    }

    private getGetCarrierServices() {
        this.cseService.getAllCarrierServices().subscribe(result => {
            this.carrierServiceList = result;
        });
    }

    public equipmentClassChange(evt: any) {
        var id = evt.target ? evt.target.value : evt;
        this.searchTrailerEquipmentClassList.forEach(t => {
            t.isChecked = false;
        });
        if (id > 0) {
            this.filteredTrailerEquipmentClassList = Object.assign([], this.searchTrailerEquipmentClassList);
            this.filteredTrailerEquipmentClassList = this.filteredTrailerEquipmentClassList.filter(t => t.equipmentClassID == id);
            this.filteredTrailerEquipmentClassList.forEach(t => {
                t.isChecked = true;
            });
        }
        else {
            this.filteredTrailerEquipmentClassList = Object.assign([], this.searchTrailerEquipmentClassList);
        }
        //console.log("equipmentClassChange", evt);
    }

    public isFieldInvalid(fld: string) {
        var isInvalid: boolean = false;
        if (fld == "domiciledCityID") {
            isInvalid = !(this.searchCarrierCriteria.domiciledCityID > 0)
                && (this.searchCarrierCriteria.domiciledRadiusMiles == null || this.searchCarrierCriteria.domiciledRadiusMiles < 0)
                //&& this.searchCarrierCriteria.domiciledRadiusMiles > 0;
        }
        else if (fld == "domiciledRadiusMiles") {
            isInvalid = (this.searchCarrierCriteria.domiciledRadiusMiles == null || this.searchCarrierCriteria.domiciledRadiusMiles < 0)
            //isInvalid = this.searchCarrierCriteria.domiciledCityID > 0
            //    && !(this.searchCarrierCriteria.domiciledRadiusMiles > 0);
        }
        if (fld == "originCityID") {
            isInvalid = !(this.searchCarrierCriteria.originCityID > 0) && (
                this.searchCarrierCriteria.originRadiusMiles > 0
                || this.searchCarrierCriteria.destinationCityID > 0
                || this.searchCarrierCriteria.destinationRadiusMiles > 0
                || this.searchCarrierCriteria.modeID > 0
                || this.searchCarrierCriteria.trailerTypeID > 0
            );
        }
        else if (fld == "originRadiusMiles") {
            isInvalid = !(this.searchCarrierCriteria.originRadiusMiles > 0) && (
                this.searchCarrierCriteria.originCityID > 0
                || this.searchCarrierCriteria.destinationCityID > 0
                || this.searchCarrierCriteria.destinationRadiusMiles > 0
                || this.searchCarrierCriteria.modeID > 0
                || this.searchCarrierCriteria.trailerTypeID > 0
            );
        }
        if (fld == "destinationCityID") {
            isInvalid = !(this.searchCarrierCriteria.destinationCityID > 0) && (
                this.searchCarrierCriteria.originCityID > 0
                || this.searchCarrierCriteria.originRadiusMiles > 0
                || this.searchCarrierCriteria.destinationRadiusMiles > 0
                || this.searchCarrierCriteria.modeID > 0
                || this.searchCarrierCriteria.trailerTypeID > 0
            );
        }
        else if (fld == "destinationRadiusMiles") {
            isInvalid = !(this.searchCarrierCriteria.destinationRadiusMiles > 0) && (
                this.searchCarrierCriteria.originCityID > 0
                || this.searchCarrierCriteria.originRadiusMiles > 0
                || this.searchCarrierCriteria.destinationCityID > 0
                || this.searchCarrierCriteria.modeID > 0
                || this.searchCarrierCriteria.trailerTypeID > 0
            );
        }
        else if (fld == "modeID") {
            isInvalid = !(this.searchCarrierCriteria.modeID > 0) && (
                this.searchCarrierCriteria.originCityID > 0
                || this.searchCarrierCriteria.originRadiusMiles > 0
                || this.searchCarrierCriteria.destinationCityID > 0
                || this.searchCarrierCriteria.destinationRadiusMiles > 0
                || this.searchCarrierCriteria.trailerTypeID > 0
                );
        }
        else if (fld == "trailerTypeID") {
            isInvalid = !(this.searchCarrierCriteria.trailerTypeID > 0) && (
                this.searchCarrierCriteria.originCityID > 0
                || this.searchCarrierCriteria.originRadiusMiles > 0
                || this.searchCarrierCriteria.destinationCityID > 0
                || this.searchCarrierCriteria.destinationRadiusMiles > 0
                || this.searchCarrierCriteria.modeID > 0
            );
        }
        return isInvalid;
    }

    public isSearchInvalid() {
        var isInvalid: boolean = false;
        if (this.searchType == "domiciled") {
            isInvalid = this.isFieldInvalid("domiciledCityID")
                || this.isFieldInvalid("domiciledRadiusMiles");
        }
        else if (this.searchType == "lane") {
            isInvalid = this.isFieldInvalid("originCityID")
                || this.isFieldInvalid("originRadiusMiles")
                || this.isFieldInvalid("destinationCityID")
                || this.isFieldInvalid("destinationRadiusMiles")
                || this.isFieldInvalid("modeID")
                || this.isFieldInvalid("trailerTypeID");
        }
        return isInvalid
    }

    public getSearchCarrierList() {
        this.isLoading = true;

        //this.searchCarriers.length = 0;
        //this.filteredSearchCarriers.length = 0;

        var equipmentIDs: number[] = [];
        this.filteredTrailerEquipmentClassList.forEach(t => {
            if (t.isChecked == true) {
                equipmentIDs.push(t.trailerTypeID);
            }
        });

        var serviceIDs: number[] = [];
        this.carrierServiceList.forEach(t => {
            if (t.isChecked == true) {
                serviceIDs.push(t.carrierServiceID);
            }
        });

        this.searchCarrierCriteria.equipmentClassIDs = equipmentIDs.join(",");
        this.searchCarrierCriteria.carrierServiceIDs = serviceIDs.join(",");

        //var criteria: SearchCarrierListCriteria = {
        //    domiciledOrigin: "",
        //    domiciledOriginID: "",
        //    domiciledDestination: "",
        //    domiciledDestinationID: "",
        //    equipmentClassID: 0,
        //    trailerIDs: "",
        //    serviceID: 0,
        //    serviceIDs: "10,11"
        //}
        this.cseService.getSearchCarrier(this.searchCarrierCriteria).subscribe(result => {
            this.isLoading = false;
            this.searchCarrierList = result.resultCollection;
            this.setSearchGrid();
            //console.log("searchCarriers", this.searchCarrierListCriteria, this.searchCarriers.length, this.searchCarriers);
        });
    }

    public clearSearchCarrierList() {
        this.initValues();
        //this.equipmentClassChange(0);
        this.filteredTrailerEquipmentClassList = Object.assign([], this.searchTrailerEquipmentClassList);
        this.filteredTrailerEquipmentClassList.forEach(t => {
            t.isChecked = false;
        });
        this.carrierServiceList.forEach(t => {
            t.isChecked = false;
        });
        this.setSearchGrid();
    }

    public addCarrier() {
        this.isAddCarrier = true;
    }

    private setSearchGrid() {
        this.filteredSearchCarrierList = Object.assign([], this.searchCarrierList);
        this.searchGridData = process(this.filteredSearchCarrierList, this.searchGridState);
        this.fitColumns();
        console.log("setSearchGrid", this.searchGridData, this.filteredSearchCarrierList);
    }

    private fitColumns() {
        this.ngZone.onStable.asObservable().pipe(take(1)).subscribe(() => {
            if (this.carrierSearchGrid == null) return;
            this.carrierSearchGrid.autoFitColumns();
        });
    }

    public rowCallback(context: RowClassArgs) {
        const isHardContact = (context.dataItem.hardContact == true);
        const isSoftContacted = (context.dataItem.softContacted == true);
        if (isHardContact) {
            return {
                success: isHardContact
            }
        }
        else if (isSoftContacted) {
            return {
                warning: isSoftContacted
            }
        }
    }
    public searchDataStateChange(state: DataStateChangeEvent): void {
        this.searchGridState = state;
        this.setSearchGrid();
        //this.searchGridData = process(this.searchCarrierList, this.searchGridState);
    }

    public onCarrierChange(evt: any) {
        var carrierID: number = 0;
        if (!isNaN(evt) && evt != null) {
            carrierID = evt;
        }
        this.carrierID = carrierID;
        this.onCarrierClick.emit(carrierID);
        //console.log("carrier-list-grid:onCarrierChange", this.originalQuoteOrderLineID, evt, selectedCarrier);

        this.isLoading = true;
        this.cseService.getSearchCarrierByCarrierID(carrierID).subscribe(result => {
            this.isLoading = false;
            this.isAddCarrier = false;
            this.carrier = result.resultCollection[0];
            console.log("onCarrierChange", this.carrier, result);
        });
        //if (selectedCarrier == null) return;
    }
}
